import { createLayer } from '@/services/map-services/layers';
import { LayerDetailsMapMutationCodes } from '@/store/modules/layer-details-map/mutations';
import { LayerDetailsService } from '@/services/layer-details-service';
import { TransformToWebExtent } from '@/services/map-services/ol-helpers';
const layerService = new LayerDetailsService();
export const actions = {
    async zoom({ state }, index) {
        state.ol.view.setZoom(state.ol.view.getZoom() + index);
    },
    async home({ state }) {
        state.ol.view.setZoom(state.ol.home.zoom);
        state.ol.view.setCenter(state.ol.home.center);
    },
    async resetSelection({ state }) {
        state.ol.selectionLayer?.getSource()?.clear();
    },
    async init({ state, commit }) {
        commit(LayerDetailsMapMutationCodes.SET_MAP_OBJECT, state.basemaps);
    },
    async addLayer({ state, commit, dispatch }, layerId) {
        const layerResult = await layerService.Get(layerId);
        if (layerResult.ok) {
            const mapLayerResult = createLayer(layerResult.val);
            if (mapLayerResult.ok) {
                commit(LayerDetailsMapMutationCodes.ADD_MAP_LAYER, mapLayerResult.val);
                if (layerResult.val.extents.spatial !== null) {
                    const extent = TransformToWebExtent(layerResult.val.extents.spatial.bbox, `EPSG:${layerResult.val.extents.spatial.crs}`);
                    /* if (extent.ok) {
                        commit(LayerDetailsMapMutationCodes.ZOOM_TO_EXTENT, extent.val)
                      } */
                }
            }
            else {
                console.log(mapLayerResult.val);
            }
        }
        else {
            console.log(layerResult.val);
        }
    },
};
